(function(){
  if (window.__lezaWL) return;
  window.__lezaWL = true;
  var KEY = 'leza_wishlist';
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function set(a){ try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent('leza:wishlist', { detail: a })); }
  function paint(){
    var l = get();
    document.querySelectorAll('.leza-heart').forEach(function(b){
      var on = l.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.leza-heart');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.dataset.handle, l = get(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    set(l);
    paint();
  }, true);
  var t;
  new MutationObserver(function(){ clearTimeout(t); t = setTimeout(paint, 50); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', paint);
  paint();
  window.lezaWishlist = { get: get, set: set, paint: paint };
})();
